/**
 * Recently Played Games Store Collection for Caliente
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var BaseCollection = require('stores/recently-played-games/recently-played-games.collection');

    module.exports = BaseCollection.extend({
        gamesLimit: 40,

        add: function(gameCodes, options) {
            options = _.extend({}, options, {at: 0});
            if (!gameCodes) {
                return;
            }

            gameCodes = _.isArray(gameCodes) ? gameCodes : [gameCodes];

            _.each(gameCodes, function(gameCode) {
                var model = _.isObject(gameCode) ? gameCode : {
                    code: gameCode
                };

                var duplicate = this.findWhere({code: model.code});

                if (duplicate) {
                    this.remove(duplicate);
                } else if (this.length >= this.gamesLimit) {
                    this.pop(); // changed just this string to delete last element in array
                }

                return BaseCollection.prototype.add.call(this, model, options);
            }, this);
        }
    });
});
